import * as _ from 'lodash'

/*
    A mixin providing efficient access to participant data for a designated patient
    being viewed by a practitioner or admin. It is similar to PatientPageMixin, but it
    requires a participantId prop to identify the patient.

    This should only be used for practitioner- or admin-facing pages, and the using
    component must have a participantId prop.
    Components within these pages that need access to the participant data should
    typically declare a participant computed variable rather than using this mixin -
    unless they contain special logic for loading or saving the participant.
    In most cases the top-level page will handle loading and saving, and embedded
    components will simply reflect the participant data.
 */

export default {
    computed: {
        participant () {
            return this.$store.state.patientParticipant
        },
        provider() {
            return this.$store.state.patientParticipantProvider
        },
    },
    methods: {
        loadParticipant (force = false) {
            // NB: this store action will determine whether the participant
            // data has already been loaded, and will debounce multiple requests
            return this.$store.dispatch(
                'getPatientParticipant',
                { participantId: this.participantId, force: force })
        },
        saveParticipant () {
            // NB: this action reloads the participant after saving
            this.$store.dispatch('savePatientParticipant')
        },
    },
    mounted () {
        if (!this.participantId) {
            console.error('Missing participantId prop, required by PractitionerPatientMixin')
        }
        this.loadParticipant()
    }
}
